import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { CurriculumConstants } from '../../../curriculum/constants/curriculum.contants';
import { ConfirmationService } from 'primeng/api';
import { NameCode } from '../../models/name-code';
import { SharedConstants } from '../../constants/shared-constants';

@Component({
  selector: 'app-unassign-training-item-group-slider',
  templateUrl: './unassign-training-item-group-slider.component.html',
  styleUrls: ['./unassign-training-item-group-slider.component.scss']
})
export class UnassignTrainingItemGroupSliderComponent implements OnInit {
  @Input() isUnAssignTrainingItemGroupSliderOpen: boolean = false;
  @Input() curriculumScopeId: string = '';
  @Input() trainingItemGroups: NameCode[] = [];
  @Output() isUnAssignTrainingItemGroupSliderActive = new EventEmitter<boolean>();
  @Output() refreshOnUnAssignTrainingItemGroups = new EventEmitter<boolean>();
  @Output() selectedTrainingItemGroupsList = new EventEmitter<string[]>();
  @Output() unassignTrainingItemGroups = new EventEmitter<void>();
  @Output() getTrainingItemGroupsList = new EventEmitter<void>();

  unAssignTrainingItemGroupHeaderText = CurriculumConstants.Curriculum_UnAssign_Training_Item_Group_Header_Text;
  valueField = SharedConstants.CodeField;
  labelField = SharedConstants.NameField;
  isSaveEnabled = false;
  selectedTrainingItemGroups: string[] = [];

  constructor(
    private confirmationService: ConfirmationService,
  ) { }

  ngOnInit(): void {
    this.getTrainingItemGroups();
  }

  getTrainingItemGroups = () => {
    this.getTrainingItemGroupsList.emit()
  }

  enableOrDisableUnAssignTrainingItemGroupsSaveBtn = () => {
    this.isSaveEnabled = this.selectedTrainingItemGroups.length > 0;
  }

  unAssignTrainingItemGroups(){
    this.selectedTrainingItemGroupsList.emit(this.selectedTrainingItemGroups);
    this.unassignTrainingItemGroups.emit();
  }

  openConfirmationModal(): void {
    this.confirmationService.confirm({
      header: SharedConstants.UnAssign_Training_Item_Group_Confirmation_Header_Text,
      message: SharedConstants.UnAssign_Training_Item_Group_Confirmation_Message_Text,
      icon: 'pi pi-exclamation-triangle',
      accept: () => this.closeSlider(false),
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times'
    });
  }

  closeSlider = (isRefresh: boolean) => {
    this.resetSlider();
    this.isUnAssignTrainingItemGroupSliderOpen = false;
    this.isUnAssignTrainingItemGroupSliderActive.emit(this.isUnAssignTrainingItemGroupSliderOpen);
    this.refreshOnUnAssignTrainingItemGroups.emit(isRefresh);
  }

  private resetSlider = () => {
    this.selectedTrainingItemGroups = [];
    this.trainingItemGroups = [];
    this.isSaveEnabled = false;
  }
}
